@if (!loggedIn()) {
  <div class="header">
    <h1>
      <lp-typewriter text="LEAP" [speed]="200" />
    </h1>
    <img src="assets/svg/spyro-soft-logo-mini.svg" alt="spyrosoft logo" />
  </div>
  <button type="button" lp-button (ariaEvent)="login()">
    {{ 'auth.login' | translate }}
  </button>
}
<lp-support-mail />
